import { Box, Typography, Avatar, Grid } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { useEffect, useState } from "react";
import HandOutContent from "./HandOutContent";
import DocumentViewer from "./DocumentViewer";
import { useLocation, useParams } from "react-router-dom";
import { ContentsService } from "services/ContentsService";
import { PurchasesService } from "services/PurchasesService";
import { Purchase } from "types";
import dayjs from "dayjs";

const handoutData = [
  {
    section: "Drawing Fundamentals 1: Basic Skills & Sketching Accurately",
    files: [
      {
        title: "Structuralism",
        url: `${process.env.PUBLIC_URL}/test.pdf`,
        type: "pdf",
      },
      {
        title: "Functionalism",
        url: `${process.env.PUBLIC_URL}/testpdf2.pdf`,
        type: "pdf",
      },
      {
        title: "Psychoanalysis",
        url: `${process.env.PUBLIC_URL}/test.pdf`,
        type: "pdf",
      },
    ],
  },
  // Add more sections as needed
];

const videoData = [
  {
    section: "Drawing Fundamentals 1: Basic Skills & Sketching Accurately",
    videos: [
      {
        title: "Structuralism",
        url: `${process.env.PUBLIC_URL}/testVideo.mp4`,
        type: "video",
      },
      {
        title: "Functionalism",
        url: "https://www.youtube.com/watch?v=nhbozauzVwM",
        type: "video",
      },
      {
        title: "Psychoanalysis",
        url: "https://www.youtube.com/shorts/R_w0dtVOHms",
        type: "video",
      },
      {
        title: "Behaviorism",
        url: `${process.env.PUBLIC_URL}/testVideo.mp4`,
        type: "video",
      },
    ],
  },
  // Add more sections as needed
];

const HandoutOverViewData = () => {
  const { id } = useParams<{ id: string }>();

  const [overViewHandoutData, setOverViewHandoutData] = useState<Purchase[] | null>(null);
  const [purchaseId, setPurchaseId] = useState<string | null>(null);
  const [activeSection, setActiveSection] = useState("expect");
  const [currentDocument, setCurrentDocument] = useState({
    url: `${process.env.PUBLIC_URL}/test.pdf`,
    type: "pdf",
  });


  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        console.error("Purchase ID is undefined");
        return;
      }

      try {
        // Fetch the purchase by its ID
        const purchasedData = await PurchasesService.getPurchasesed(id);

        // // Fetch user data related to the purchase
        // const contentData = await ContentsService.getUserByCreatedBy(purchasedData?.contentData?.createdBy);
        // console.log("contentDatassssssss", contentData);

        if (purchasedData) {
          setOverViewHandoutData([purchasedData]); // Wrap in an array for consistency
          setPurchaseId(purchasedData.id); // Set the purchase ID


        } else {
          console.warn("No purchase found for this ID.");
        }
      } catch (error) {
        console.error("Error fetching purchase data:", error);
      }
    };

    fetchData();
  }, [id]);



  useEffect(() => {
    if (purchaseId) {
      // Additional logic using `purchaseId` can go here
    }
  }, [purchaseId]);

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
  };

  const handleDocumentChange = (doc: { url: string; type: string }) => {
    setCurrentDocument(doc);
  };

  return (
    <Box sx={styleSheet.mainContainer}>

      {overViewHandoutData?.map((purchase) => (

        <>
          <Box sx={styleSheet.headerContainer}>

            {purchase?.contentData?.title}
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            px={{ xs: 1, md: 0 }}
            key={purchase.id}
          >
            <Box
              display={"flex"}
              gap={1}
              flexDirection={{ xs: "column", md: "row" }}
            >
              <DocumentViewer
                document={currentDocument}
                purchase={purchase}
              />
              <Box sx={styleSheet.cardContainer} >
                <HandOutContent
                  handoutData={handoutData}
                  purchase={purchase}
                  videoData={videoData}
                  onDocumentSelect={handleDocumentChange}
                />
              </Box>
            </Box>
            {/* Additional content */}
            <Box
              display={"flex"}
              gap={{ xs: 0, md: 3 }}
              alignItems={"center"}
              pt={1}
              flexWrap={{ xs: "nowrap", md: "wrap" }}
              overflow={{ xs: "auto", md: "visible" }}
              sx={{
                scrollbarWidth: "none", // Hide scrollbar on Firefox
                "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar on Chrome, Safari, and Edge
              }}
            >
              <Grid
                display={"flex"}
                minWidth={{ xs: "200px", md: "0px" }}
                alignItems={"center"}
                gap={1}
              >
                <Avatar
                  alt="Remy Sharp"
                  src={purchase?.contentData?.createdBy?.profileUrl || "/static/images/avatar/1.jpg"}
                  sx={{ width: 40, height: 40 }}
                />
                <Box fontSize={"17px"} fontWeight={700} color={"#000000"}>
                  {purchase?.contentData?.createdBy?.firstName} {purchase?.contentData?.createdBy?.lastName}

                </Box>
              </Grid>
              <Grid
                display={"flex"}
                minWidth={{ xs: "320px", md: "0px" }}
                alignItems={"center"}
                gap={1}
              >
                {/* <PlayCircleIcon fontSize="large" color="primary" /> */}
                <img
                  src="/assets/icons/sourceOfKnowledge.svg"
                  alt="course"
                  style={{ width: "30px", height: 30, objectFit: "cover" }}
                />
                <Box sx={styleSheet.textHeading}>
                  {/* Scientific Research, Experimental */}
                  {/* {purchase?.contentData?.sourceOfKnowledge} */}
                  {Array.isArray(purchase?.contentData?.sourceOfKnowledge)
                    ? purchase?.contentData?.sourceOfKnowledge.join(", ")
                    : purchase?.contentData?.sourceOfKnowledge.replace(/\//g, " / ")}
                </Box>
              </Grid>
              <Grid
                display={"flex"}
                minWidth={{ xs: "300px", md: "0px" }}
                alignItems={"center"}
                gap={1}
              >
                <img
                  src="/assets/icons/categoryReview.svg"
                  alt="course"
                  style={{ width: "30px", height: 30, objectFit: "cover" }}
                />
                <Box sx={styleSheet.textHeading}>
                  {/* {purchase?.contentData?.category} */}
                  {Array.isArray(purchase?.contentData?.category)
                    ? purchase?.contentData?.category.join(", ")
                    : purchase?.contentData?.category.replace(/\//g, " / ")}
                </Box>
              </Grid>
              <Grid
                display={"flex"}
                alignItems={"center"}
                gap={1}
                minWidth={{ xs: "115px", md: "0px" }}
              >
                <img
                  src="/assets/icons/iconType.svg"
                  alt="course"
                  style={{ width: "30px", height: 30, objectFit: "cover" }}
                />
                <Box sx={styleSheet.textHeading}>{purchase?.contentData?.type}</Box>
              </Grid>
              <Grid display={"flex"} alignItems={"center"} gap={1}>
                <img
                  src="/assets/icons/calandar.svg"
                  alt="user"
                  style={{ width: 26, height: 26 }}
                />
                <Box sx={styleSheet.textHeading}>

                  {purchase?.contentData?.createdAt
                    ? dayjs(purchase.contentData.createdAt.toDate()).format("MM/DD/YYYY")
                    : "No Date Available"}

                </Box>
              </Grid>
            </Box>
            <Typography
              sx={{ borderBottom: "1px solid #F0F0F0", mt: 2 }}
            ></Typography>
            <Box display={"flex"} flexDirection={"column"} gap={1}>
              <Box display={"flex"} gap={{ xs: 3, md: 8 }}>
                <Typography
                  onClick={() => handleSectionChange("expect")}
                  fontWeight={700}
                  fontSize={"18px"}
                  color={activeSection === "expect" ? "#233F91" : "#676767"}
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      width: "100%",
                      height: "4px",
                      bottom: "-8px",
                      borderTopRightRadius: "5px",
                      borderTopLeftRadius: "5px",
                      left: 0,
                      backgroundColor:
                        activeSection === "expect" ? "#233F91" : "transparent",
                    },
                  }}
                >
                  What to Expect from this Content
                </Typography>
                <Typography
                  onClick={() => handleSectionChange("summary")}
                  fontWeight={700}
                  fontSize={"18px"}
                  color={activeSection === "summary" ? "#233F91" : "#676767"}
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      width: "100%",
                      height: "4px",
                      bottom: "-8px",
                      borderTopRightRadius: "5px",
                      borderTopLeftRadius: "5px",
                      left: 0,
                      backgroundColor:
                        activeSection === "summary" ? "#233F91" : "transparent",
                    },
                  }}
                >
                  Summary
                </Typography>
              </Box>

              <Typography sx={{ borderBottom: "1px solid #F0F0F0" }}></Typography>
            </Box>
            {activeSection === "expect" && (
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={3}
                px={{ xs: 2, md: 0 }}
              >
                {/* <Typography sx={styleSheet.content}>
                  Donec sed erat ut magna suscipit mattis. Aliquam erat volutpat.
                  Morbi in orci risus. Donec pretium fringilla blandit. Etiam ut
                  accumsan leo. Aliquam id mi quam. Vivamus dictum ut erat nec
                  congue. Etiam facilisis lacus ut arcu vulputate, non pellentesque
                  sem convallis. Proin tempus sapien nisl, nec varius risus
                  tristique a. Etiam ligula lacus, ultricies at cursus id, fringilla
                  nec nulla.
                </Typography>
                <Typography sx={styleSheet.content}>
                  Fusce pretium laoreet diam a mollis. In finibus purus sed tortor
                  fringilla, eu luctus lorem sodales.Ut dignissim ante ac augue
                  vulputate tristique. Mauris venenatis tincidunt nibh, sit amet
                  fringilla augue malesuada a. Mauris a nunc congue, viverra lectus
                  sed, imperdiet quam. Aenean tempor sem sed lorem ultricies
                  lacinia.
                </Typography> */}
                <Typography sx={styleSheet.content}>
                  {purchase?.contentData?.expectations}
                </Typography>
              </Box>
            )}

            {activeSection === "summary" && (
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={3}
                px={{ xs: 2, md: 0 }}
              >
                {/* <Typography sx={styleSheet.content}>
                  magna suscipit Donec sed erat ut magna suscipit mattis. Aliquam
                  erat volutpat. Morbi in orci risus. Donec pretium fringilla
                  blandit. Etiam ut accumsan leo. Aliquam id mi quam. Vivamus dictum
                  ut erat nec congue. Etiam facilisis lacus ut arcu vulputate, non
                  pellentesque sem convallis. Proin tempus sapien nisl, nec varius
                  risus tristique a. Etiam ligula lacus, ultricies at cursus id,
                  fringilla nec nulla.
                </Typography>
                <Typography sx={styleSheet.content}>
                  Fusce pretium laoreet diam a mollis. In finibus purus sed tortor
                  fringilla, eu luctus lorem sodales.Ut dignissim ante ac augue
                  vulputate tristique. Mauris venenatis tincidunt nibh, sit amet
                  fringilla augue malesuada a. Mauris a nunc congue, viverra lectus
                  sed, imperdiet quam. Aenean tempor sem sed lorem ultricies
                  lacinia.
                </Typography> */}
                <Typography sx={styleSheet.content}>
                  {purchase?.contentData?.summary}
                </Typography>
              </Box>
            )}
          </Box>
        </>

      ))
      }


    </Box >
  );
};

export default HandoutOverViewData;

const styleSheet = {
  mainContainer: {
    p: { xs: 0, md: 5 },
    // px: { xs: 1, md: 0 }
  },
  headerContainer: {
    pt: { xs: 4, md: 3 },
    pb: 3,
    px: { xs: 1, md: 0 },
    fontWeight: 500,
    fontSize: { xs: "23px", md: "28px" },
    color: "#233F91",
    lineHeight: "27.6px",
  },
  cardContainer: {
    borderRadius: "15px",
    display: "flex",
    backgroundColor: "#FBFBFB",
    boxShadow: "0px 1px 1px 1px rgba(0, 0, 0, 0.25)",
    p: 1,
    flexDirection: "column",
    border: "1px solid #F2F2F2",
    gap: 3,
    // width: "450px",
    // height: "587px",
  },
  addToCardBtn: {
    width: "301px",
    height: "57px",
    borderRadius: "15px",
    bgcolor: "#233F91",
    fontSize: "17px",
    fontWeight: "400",
    color: "#fff",
    "&:hover": {
      bgcolor: "#1A73E8",
    },
  },
  textHeading: {
    fontSize: "17px",
    fontWeight: 400,
    color: "#676767",
  },
  content: {
    mt: 2,
    fontSize: { xs: "20px", md: "22px" },
    fontWeight: 400,
    color: "#676767",
  },
};
